import { HookNavGet, HookPageLocation } from 'Hook'
import { TypeControlPageLocation, TypeNavHttpControl } from 'Type'

const HookNavPage = <T>() :TypeNavHttpControl<T> => {
    const locationControl :TypeControlPageLocation = HookPageLocation();
    return HookNavGet({linkTo: locationControl.location, paramUpdates: [{type: 'context', values: ['true']}]})
}

export default HookNavPage